interface FilterChipProps {
  /** Text shown in the chip. */
  label: string;
  /** Accessible label for the remove control, e.g. "Remove teacher Smith filter". */
  removeLabel: string;
  onRemove: () => void;
}

/**
 * A small dismissible filter chip (built on the Badge visual language). The
 * remove control is a real button so Enter/Space work natively; `removeLabel`
 * gives screen readers the full context the visible "×" lacks.
 */
export function FilterChip({ label, removeLabel, onRemove }: FilterChipProps) {
  return (
    <span
      data-testid="filter-chip"
      className="inline-flex items-center gap-1 rounded bg-surface-2/60 border border-border-subtle pl-2 pr-1 py-0.5 text-xs font-medium text-text-soft"
    >
      <span className="max-w-[160px] truncate">{label}</span>
      <button
        type="button"
        onClick={onRemove}
        onKeyDown={(e) => {
          // Enter/Space fire onClick natively; add Backspace/Delete so a chip
          // can be dismissed with the keys users reach for.
          if (e.key === "Backspace" || e.key === "Delete") {
            e.preventDefault();
            onRemove();
          }
        }}
        aria-label={removeLabel}
        className="flex h-4 w-4 items-center justify-center rounded text-text-muted hover:text-white hover:bg-surface-2 focus:outline-none focus:ring-1 focus:ring-brand"
      >
        <span aria-hidden="true" className="text-[13px] leading-none">
          ×
        </span>
      </button>
    </span>
  );
}
